"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var EventHandler = /*#__PURE__*/function () {
  function EventHandler(setStateValues) {
    (0, _classCallCheck2["default"])(this, EventHandler);
    this.setStateValues = setStateValues;
    this.displayName = 'TypeaheadInputEventHandler';
  }

  (0, _createClass2["default"])(EventHandler, [{
    key: "onChange",
    value: function onChange(selected) {
      // it's possible to enhance this to handle multiple selections in the future
      if (selected.length) {
        this.setStateValues({
          storedValue: selected[0]
        });
      } else {
        this.setStateValues({
          storedValue: ''
        });
      }
    }
  }, {
    key: "onSearch",
    value: function onSearch(value) {
      this.setStateValues({
        storedValue: value
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      // https://reactjs.org/docs/events.html#event-pooling
      event.persist();
      this.setStateValues({
        storedValue: event.target.value,
        dirty: event.target.value.length > 0,
        complete: true,
        isFocused: false
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setStateValues({
        dirty: true,
        isFocused: true
      });
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(value) {
      this.setStateValues({
        storedValue: value,
        dirty: value.length > 0,
        complete: true,
        isFocused: false
      });
    }
  }]);
  return EventHandler;
}();

var _default = EventHandler;
exports["default"] = _default;